"use client";

import { NiceToMeetYou } from "@/components/NiceToMeetYou";
import HomeMore from "@/components/pages/home/HomeMore";
import { HowWeDoIt } from "@/components/pages/home/HowWeDoIt";
import WhatWeDoExpertises from "@/components/pages/what-we-do/WhatWeDoExpertises";
import WhatWeDoHero from "@/components/pages/what-we-do/WhatWeDoHero";
import WhatWeDoServiceCampaign from "@/components/pages/what-we-do/services/WhatWeDoServiceCampaign";
import WhatWeDoServiceIdentity from "@/components/pages/what-we-do/services/WhatWeDoServiceIdentity";
import WhatWeDoServicePhotoVideo from "@/components/pages/what-we-do/services/WhatWeDoServicePhotoVideo";
import WhatWeDoServiceStrategy from "@/components/pages/what-we-do/services/WhatWeDoServiceStrategy";
import WhatWeDoServiceWebdesign from "@/components/pages/what-we-do/services/WhatWeDoServiceWebdesign";
import applyPageTransition from "lib/usePageTransition";
import { usePageTransition } from "mono/third-party/react-page-transitions-custom";
import Head from "next/head";

export default function WhatWeDoPage() {
  const { transitionState, from, to, data } = usePageTransition({
    ...applyPageTransition("WHAT_WE_DO"),
  });

  return (
    <>
      <Head>
        <title>Nine Creative Agency: What We Do</title>
      </Head>

      <WhatWeDoHero />
      <WhatWeDoExpertises />

      <>
        <WhatWeDoServiceIdentity />
        <WhatWeDoServiceStrategy />
        <WhatWeDoServiceWebdesign />
        <WhatWeDoServicePhotoVideo />
        <WhatWeDoServiceCampaign />
        <HowWeDoIt />
        <HomeMore />
      </>

      <NiceToMeetYou />
    </>
  );
}
